<script setup>
import { reactiveOmit } from "@vueuse/core";
import { ScrollAreaScrollbar, ScrollAreaThumb } from "reka-ui";
import { cn } from "@/lib/utils";

const props = defineProps({
  orientation: { type: String, required: false, default: "vertical" },
  forceMount: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
});

const delegatedProps = reactiveOmit(props, "class");
</script>

<template>
  <ScrollAreaScrollbar
    v-bind="delegatedProps"
    :class="
      cn(
        'vf-flex vf-touch-none vf-select-none vf-transition-colors',
        orientation === 'vertical' &&
          'vf-h-full vf-w-2.5 border-l vf-border-l-transparent vf-p-px',
        orientation === 'horizontal' &&
          'vf-h-2.5 vf-flex-col vf-border-t vf-border-t-transparent vf-p-px',
        props.class
      )
    "
  >
    <ScrollAreaThumb
      class="vf-relative vf-flex-1 vf-rounded-full vf-bg-border"
    />
  </ScrollAreaScrollbar>
</template>
